"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hideInput(el) {
    el.style.position = 'absolute';
    el.style.top = "0";
    el.style.left = "0";
    el.style.width = "0";
    el.style.height = "0";
    el.style.display = "none";
}
/**Obtiene un arreglo con los archivos seleccionados en un input. Devuelve null si no se seleccionó ningun archivo */
function getFiles(input) {
    if (!input.files || input.files.length == 0)
        return null;
    const multi = input.multiple;
    const inputFiles = input.files;
    const fileArray = [];
    for (let i = 0; i < inputFiles.length; i++) {
        fileArray.push(inputFiles[i]);
    }
    return fileArray;
}
function upload(multi) {
    //Creamos un elemento input escondido:
    const input = document.createElement("input");
    input.type = "file";
    hideInput(input);
    input.multiple = multi || false;
    //Lo agregamos al documento:
    document.body.appendChild(input);
    return new Promise(resolve => {
        input.onchange = (ev) => {
            const files = getFiles(input);
            const ret = files && (multi ? files : files[0]);
            //Quitamos el input del documento:
            document.body.removeChild(input);
            resolve(ret);
        };
        /**Bandera que indica si se debe de revisar si el input se cancelo, esto porque sólo se debe de hacer una vez */
        let checkCancel = true;
        function onBodyFocus() {
            if (!checkCancel)
                return;
            checkCancel = false;
            if (onfocus)
                document.body.removeEventListener("focus", onfocus);
            //Realizamos el chequeo con un retraso, si lo revisamos inmediatamente el valor de input.value aun no
            //estará actualizado
            setTimeout(() => {
                if (!input.value) {
                    //El usuario no seleccionó ningún archivo
                    resolve(null);
                }
            }, 100);
        }
        document.body.addEventListener("focus", onBodyFocus, true);
        input.click();
    });
}
exports.upload = upload;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/upload.js
// module id = 2263
// module chunks = 0